import Vue from 'vue'

import { list, show, update, create, remove } from './priceTableServices'

const state = {
  priceTable: {},
  priceTables: [],
  priceTableId: null,
  isPriceTableLoading: false,
}

const getters = {
  priceTable: (state) => state.priceTable,
  priceTables: (state) => state.priceTables,
  priceTableId: (state) => state.priceTableId,
  isPriceTableLoading: (state) => state.isPriceTableLoading,
}

const actions = {
  async fetchPriceTable({ commit, dispatch }, priceTableId) {
    commit('setIsPriceTableLoading', true)

    try {
      const { data } = await show(priceTableId)
      commit('setPriceTable', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsPriceTableLoading', false)
    }
  },

  async fetchPriceTables({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await list(params)
      const { result, total } = data

      commit('setPriceTables', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  handleOpenCreateEditPriceTableModal({ dispatch, commit }, itemId) {
    commit('setPriceTable', null)
    dispatch('openModal', 'CREATE_EDIT_PRICE_TABLE_MODAL')
    itemId && dispatch('fetchPriceTable', itemId)
  },
}

const mutations = {
  setPriceTable: (state, priceTable) => {
    state.priceTable = priceTable
  },

  setPriceTables: (state, priceTables) => {
    state.priceTables = priceTables
  },

  setPriceTableId: (state, id) => {
    state.priceTableId = id
  },

  setIsPriceTableLoading: (state, status) => {
    state.isPriceTableLoading = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
